import store from '@/store';
import {
  getContractTemplates,
  getContractPdf,
  getContract,
  getAuthorizations,
  createContract,
  signContract,
  updateContractFields,
  validateOfferForContractTemplate,
  addContractStep,
  deleteContract
} from '@/backend/contracts';

const SET_CONTRACT_TEMPLATES = 'SET_CONTRACT_TEMPLATES';
const SET_CONTRACT_PDF = 'SET_CONTRACT_PDF';
const ADD_OFFER_ID = 'ADD_OFFER_ID';
const CLEAR_OFFER_IDS = 'CLEAR_OFFER_IDS';
const SET_CONTRACT = 'SET_CONTRACT';
const CLEAN_CONTRACT = 'CLEAN_CONTRACT';
const SET_AUTHORIZATIONS = 'SET_AUTHORIZATIONS';
const SET_MISSING_FIELDS = 'SET_MISSING_FIELDS';
const CLEAR_MISSING_FIELDS = 'CLEAR_MISSING_FIELDS';

const nullContract = {
  id: null,
  state: null,
  pdf_url: null,
  pdf_download_url: null,
  is_signed: false,
  can_sign: false,
  steps: []
}

const nullAuthorizations = {
  can_sign: false
}

const state = {
  contractTemplates: [],
  selectedOfferIds: [],
  contract: nullContract,
  authorizations: nullAuthorizations,
  contractPdf: null,
  missingFields: [],
}

export const actions = {
  loadContractTemplates({ commit }) {
    return getContractTemplates()
    .then(response => {
      const contractTemplates = response.data;
      commit(SET_CONTRACT_TEMPLATES, { contractTemplates: contractTemplates });
    })
    .catch(error => {
      const message = { type: 'danger', content: error.response.data };
      store.dispatch('message/enable', message, { root: true });
    })
  },
  getContractPdf({ commit }, params) {
    return getContractPdf(params)
    .then(response => {
      let contractPdf = window.URL.createObjectURL(response.data);
      commit(SET_CONTRACT_PDF, { contractPdf: contractPdf });
    })
    .catch(error => {
      const message = { type: 'danger', content: error.response.data };
      store.dispatch('message/enable', message, { root: true });
    })
  },
  validateOfferForContractTemplate({ commit, dispatch }, { offerId, templateId }) {
    return validateOfferForContractTemplate(templateId, { offer_id: offerId })
      .then(response => {
        commit(SET_MISSING_FIELDS, response.data.missings);
      })
      .catch(error => {
        const message = { type: 'danger', content: error.response.data };
        dispatch('message/enable', message, { root: true });
      })
  },
  updateContractFields({ dispatch }, { offerId, templateId, updatedFields }) {
    return updateContractFields(offerId, updatedFields)
    .then(response => {
      dispatch('validateOfferForContractTemplate', {
        offerId: offerId,
        templateId: templateId
      });
    })
  },
  clearMissingFields({ commit }) {
    commit(CLEAR_MISSING_FIELDS)
  },
  addOfferId({ commit }, offerId) {
    offerId = parseInt(offerId)
    if(!state.selectedOfferIds.includes(offerId)) {
      commit(ADD_OFFER_ID, { offerId: offerId });
    }
  },
  clearSelectedOfferIds({ commit }) {
    commit(CLEAR_OFFER_IDS);
  },
  createContract({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      createContract(params)
        .then(response => {
          commit(SET_CONTRACT, { contract: response.data });
          resolve(response.data);
        })
        .catch(error => {
          const message = { type: 'danger', content: error.response.data };
          dispatch('message/enable', message, { root: true });
          reject(error);
        });
    });
  },
  getContract({ commit, dispatch }, contractId) {
    commit(CLEAN_CONTRACT);

    return getContract(contractId)
      .then(response => {
        commit(SET_CONTRACT, { contract: response.data });
      })
      .catch(error => {
        const message = { type: 'danger', content: error.response.data };
        dispatch('message/enable', message, { root: true });
      })
  },
  delete({ commit, dispatch }, contract) {
    return new Promise((resolve) => {
      deleteContract(contract.id)
        .then(response => {
          commit(CLEAN_CONTRACT);
          resolve();
        })
        .catch(error => {
          const message = { type: 'danger', content: error.response.data };
          dispatch('message/enable', message, { root: true });
        })
    });
  },
  sign({ commit, dispatch }, contract) {
    return new Promise((resolve) => {
      signContract(contract.id)
        .then(response => {
          commit(SET_CONTRACT, { contract: response.data });
          resolve();
        })
        .catch(error => {
          const message = { type: 'danger', content: error.response.data };
          dispatch('message/enable', message, { root: true });
        })
    });
  },
  getAuthorizations({ commit, dispatch }, { contract_template_id, main_offer_id, offer_ids }) {
    return getAuthorizations(contract_template_id, { offer_ids: offer_ids, main_offer_id: main_offer_id })
      .then(response => {
        commit(SET_AUTHORIZATIONS, response.data);
      })
      .catch(error => {
        const message = { type: 'danger', content: error.response.data };
        dispatch('message/enable', message, { root: true });
      })
  },
  addStep({ commit }, { contract, comment }) {
    return addContractStep(contract.id, { comment })
    .then(response => {
      commit(SET_CONTRACT, { contract: response.data })
    })
  }
}

export const mutations = {
  [SET_CONTRACT_TEMPLATES] (state, { contractTemplates }) {
    state.contractTemplates = contractTemplates;
  },
  [SET_CONTRACT_PDF] (state, { contractPdf }) {
    state.contractPdf = contractPdf;
  },
  [ADD_OFFER_ID] (state, { offerId }) {
    state.selectedOfferIds.push(offerId);
  },
  [CLEAR_OFFER_IDS] (state) {
    state.selectedOfferIds = [];
  },
  [SET_CONTRACT] (state, { contract }) {
    state.contract = contract;
  },
  [CLEAN_CONTRACT] (state) {
    state.contract = nullContract;
  },
  [SET_AUTHORIZATIONS] (state, authorizations) {
    state.authorizations = authorizations;
  },
  [SET_MISSING_FIELDS] (state, missingFields) {
    state.missingFields = missingFields;
  },
  [CLEAR_MISSING_FIELDS] (state) {
    state.missingFields = [];
  }
}

export const getters = {
  contractTemplates: state => state.contractTemplates,
  selectedOfferIds: state => state.selectedOfferIds,
  contract: state => state.contract,
  authorizations: state => state.authorizations,
  contractPdf: state => state.contractPdf,
  selectedOfferIds: state => state.selectedOfferIds,
  missingFields: state => state.missingFields,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/contracts.js